import { render, staticRenderFns } from "./social-list.vue?vue&type=template&id=2301629a&scoped=true&"
import script from "./social-list.vue?vue&type=script&lang=js&"
export * from "./social-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2301629a",
  null
  
)

export default component.exports